<template>
    <v-card min-width="20vw" align="center" justify="center" light outlined>
        <v-card-title style="background-color: #d2d7e1">
            <v-list-item>
                <v-list-item-title><h2>{{ $t('title') }}</h2></v-list-item-title>
                <v-spacer/>
                <v-list-item-action><v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon></v-list-item-action>
            </v-list-item>
        </v-card-title>
        <v-card-text class="px-7 py-7">
            <p>{{ $t('prepend') }} <b>{{ $t('delete') }} {{ trades.length }} trade(s)</b> {{ $t('append') }}</p>
            <p class="mb-5 mt-n1"><i>({{ $t('alert') }})</i></p>
            <v-btn @click="deleteTrades">{{ $t('btnDelete') }}</v-btn>
        </v-card-text>
    </v-card>
</template>

<script>
    import { mapMutations } from 'vuex';
    import Repository from '../../../repositories/journal';
    export default {
        name: "DeleteMultipleTrades",
        props: {
            trades: Array,
        },
        methods: {
            ...mapMutations(['setTrades', 'setStats', 'setTradesPageInfo', 'setLoadingTrades']),
            deleteTrades() {
                this.setLoadingTrades(true);
                Repository.deleteMultipleTrades(this.trades).then((response) => {
                    if(response.status < 400 && response.data) {
                        let filter = this.$store.state.book.currentFilter;
                        Repository.filteredTradesOfUser(filter, this.$store.state.book.pageable).then((responseTrades) => {
                            let trades = responseTrades.data.content;
                            if(trades.length>0){
                                this.tradeTimeAvg = 0;
                                trades.forEach((item) => {
                                    item.mood = item.mood[0] + item.mood.slice(1).toLowerCase();
                                    item.side = item.side[0] + item.side.slice(1).toLowerCase();
                                    item.tradeTime = this.convertDuration(item.tradeTime);
                                    item.openTime = new Date(item.openTime);
                                    item.closeTime = new Date(item.closeTime);
                                    //item.openTime = this.convertUTCDateToLocalDate(new Date(item.openTime));
                                });
                                this.setTrades(responseTrades.data.content);
                                let stats = {tradeTimeAvg: this.secondsToHHMMSS(this.tradeTimeAvg / trades.length)};
                                this.setStats(stats);
                                this.setTradesPageInfo({totalElements: responseTrades.data.totalElements, totalPages: responseTrades.data.totalPages});
                            }else{
                                Repository.allTradesOfUser(this.$store.state.book.pageable).then((responseAllTrades) => {
                                    let trades = responseAllTrades.data.content;
                                    this.tradeTimeAvg = 0;
                                    trades.forEach((item) => {
                                        item.mood = item.mood[0] + item.mood.slice(1).toLowerCase();
                                        item.side = item.side[0] + item.side.slice(1).toLowerCase();
                                        item.tradeTime = this.convertDuration(item.tradeTime);
                                        item.openTime = new Date(item.openTime);
                                        item.closeTime = new Date(item.closeTime);
                                        //item.openTime = this.convertUTCDateToLocalDate(new Date(item.openTime));
                                    });
                                    this.setTrades(responseAllTrades.data.content);
                                    
                                    let stats = {tradeTimeAvg: this.secondsToHHMMSS(this.tradeTimeAvg / trades.length)};
                                    if (trades.length > 0) {
                                        this.setStats(stats);
                                        this.setNoTrades(false);
                                    } else{
                                        this.setNoTrades(true);
                                    }
                                    this.setTradesPageInfo({totalElements: responseAllTrades.data.totalElements, totalPages: responseAllTrades.data.totalPages});
                                });
                            }
                        });
                    }
                });
                this.closeWindow();
            },
            convertDuration(isoFormat){
                let iso8601DurationRegex = /(-)?P(?:([.,\d]+)Y)?(?:([.,\d]+)M)?(?:([.,\d]+)W)?(?:([.,\d]+)D)?T(?:([.,\d]+)H)?(?:([.,\d]+)M)?(?:([.,\d]+)S)?/;
                let matches = isoFormat.match(iso8601DurationRegex);

                // Sum to the trade time average
                this.tradeTimeAvg += (matches[8] === undefined ? 0 : matches[8] * 1) +
                    (matches[7] === undefined ? 0 : matches[7] * 60) +
                    (matches[6] === undefined ? 0 : matches[6] * 3600) +
                    (matches[5] === undefined ? 0 : matches[5] * 86400) +
                    (matches[4] === undefined ? 0 : matches[4] * 604800);

                return {
                    sign: matches[1] === undefined ? '+' : '-',
                    years: matches[2] === undefined ? 0 : matches[2],
                    months: matches[3] === undefined ? 0 : matches[3],
                    weeks: matches[4] === undefined ? 0 : matches[4],
                    days: matches[5] === undefined ? 0 : matches[5],
                    hours: matches[6] === undefined ? 0 : matches[6],
                    minutes: matches[7] === undefined ? 0 : matches[7],
                    seconds: matches[8] === undefined ? 0 : matches[8]
                };
            },
            convertUTCDateToLocalDate(date) {
                let newDate = new Date(date.getTime() + date.getTimezoneOffset()*60*1000);
                let offset = date.getTimezoneOffset() / 60;
                let hours = date.getHours();
                newDate.setHours(hours - offset);
                return newDate;
            },
            secondsToHHMMSS(secondsToConvert) {
                let sec_num = parseInt(secondsToConvert, 10); // don't forget the second param
                let hours = Math.floor(sec_num / 3600);
                let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
                let seconds = sec_num - (hours * 3600) - (minutes * 60);

                if (hours < 10)
                    hours = "0" + hours;
                if (minutes < 10)
                    minutes = "0" + minutes;
                if (seconds < 10)
                    seconds = "0" + seconds;

                return `${hours}h ${minutes}m ${seconds}s`;
            },
            closeWindow() {
                this.$emit('closeWindow');
            },
        }
    }
</script>

<i18n>
{
  "en": {
    "title": "Delete Trades",
    "prepend": "Are you fully sure to",
    "delete": "delete",
    "append": "immediately?",
    "alert": "Only trades of not verified accounts will be deleted",
    "btnDelete": "Sure, delete them"
  },
  "es": {
    "title": "Eliminar Trades",
    "prepend": "¿Estas seguro que quieres",
    "delete": "eliminar",
    "append": "inmediatamente?",
    "alert": "Solamente trades de cuentas no verificadas serán eliminados",
    "btnDelete": "Seguro, eliminar trades"
  }
}
</i18n>

<style scoped>

</style>
